import { useEnvironmentId } from '@/react/hooks/useEnvironmentId';

import { PageHeader } from '@@/PageHeader';
import { TextTip } from '@@/Tip/TextTip';

import { useIsSwarmAgent } from '../../proxy/queries/useIsSwarmAgent';
import { useIsD2k } from '../../proxy/queries/useInfo';

import { PullImageFormWidget } from './PullImageFormWidget';
import { ImagesDatatable } from './ImagesDatatable/ImagesDatatable';

export function ListView() {
  const isSwarmAgent = useIsSwarmAgent();
  const isD2k = useIsD2k(useEnvironmentId());

  return (
    <>
      <PageHeader title="Image list" breadcrumbs="Images" reload />

      {isD2k ? (
        <TextTip color="blue" className="mb-2">
          D2K keeps no images: the kubelet pulls them on the cluster&apos;s
          nodes. These are the images its containers use, to view only.
        </TextTip>
      ) : (
        <div className="row">
          <div className="col-sm-12">
            <PullImageFormWidget isNodeVisible={isSwarmAgent} />
          </div>
        </div>
      )}

      <ImagesDatatable isHostColumnVisible={isSwarmAgent} readOnly={isD2k} />
    </>
  );
}
